import { EventEmitter, Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

import { Lingua } from '../models/bo.model';
import { Errore } from '../models/dto';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  public languages: Lingua[];
  public languagesSBM: Lingua[];
  public currentLanguage: Lingua;

  public languageChanged: EventEmitter<Lingua> = new EventEmitter();

  constructor(private translate: TranslateService,
    private localStorage: LocalStorageService,
    private adapter: DateAdapter<any>) {
  }

  setDefaultLang(lang: string, save: boolean = false): Promise<void> {
    return new Promise<void>(resolve => {
      let language: Lingua;

      if (!!lang) {
        language = this.languages.find(x => x.codice == lang);
      }

      if (language == null) {
        language = this.languages.find(x => x.codice == 'it');
        lang = 'it';
      }

      if (language != null) {
        this.translate.setDefaultLang(lang);
        this.currentLanguage = language;

        this.translate.use(lang).subscribe(() => {
          moment.locale(lang == 'dk' ? 'da' : lang, { week: { dow: 1 } });

          this.adapter.setLocale(lang);
          this.adapter.getFirstDayOfWeek = () => { return 1; };

          if (save) {
            this.localStorage.set('language', lang);
          }

          this.languageChanged.emit(this.currentLanguage);

          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  getTranslationSync(id: string, interpolateParams?: Object) {
    return this.translate.instant(id, interpolateParams);
  }

  setTranslation(lang: string, json: Object) {
    this.translate.setTranslation(lang, json, true);
  }

  getTranslationFromErrori(errori: Errore[]) {
    let ret = '';

    if (errori != null && errori.length > 0) {
      for (let index = 0; index < errori.length; index++) {
        const element = errori[index];

        if (element) {
          let translation: string;

          if (element.idTraduzione && element.idTraduzione.length > 0) {
            let interpolateParams = {};

            if (element.parameters) {
              for (let parameter of element.parameters) {
                interpolateParams[parameter.name] = parameter.value;
              }
            }

            translation = this.getTranslationSync(element.idTraduzione, interpolateParams);
          } else if (element.messaggio) {
            translation = element.messaggio;
          }

          ret += translation;

          if (index < errori.length - 1) {
            ret += '<br/>';
          }
        }
      }
    }

    return ret;
  }

  getTranslationFromArray(messages: string[]) {
    let ret = '';

    if (messages != null && messages.length > 0) {
      for (let index = 0; index < messages.length; index++) {
        const element = messages[index];

        let interpolateParams = {};

        if (element && element.length > 0) {
          let translation = this.getTranslationSync(element, interpolateParams);

          ret += translation;

          if (index < messages.length - 1) {
            ret += '<br/>';
          }
        }
      }
    }

    return ret;
  }

  getCurrentLocale(): string {
    return this.translate.getDefaultLang();
  }
}